// src/modules/app-views/crm/pages/Kanban/modals/NewOpportunityModal/Step3.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import FormFieldsRenderer from '../../../../components/FormFieldsRenderer';

// *******************************************************************************
// MAIN COMPONENT
// *******************************************************************************
const Step3 = ({ formFields, columnUid }) => {
  // ─────────────────────────────────────────────────────────────────────────────
  // 1. UI
  // ─────────────────────────────────────────────────────────────────────────────
  return (
    <div className="p-2">
      <FormFieldsRenderer formFields={formFields} columnUid={columnUid} />
    </div>
  );
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default Step3;
